<div class="sh-panel">
    @if ((hasFragments$ | async) && (isLoading$ | async)) {
        <sh-notification [message]="'ui.loading' | translate"></sh-notification>
    }

    @if (!(hasVisibleFragments$ | async) && !(isLoading$ | async) && !(loadingError$ | async)) {
        <sh-notification [type]="notificationType.Update" [message]="'fragments-tab.empty.no-fragments' | translate"></sh-notification>
    }

    @if ((loadingError$ | async) && !(isLoading$ | async)) {
        <sh-notification [type]="notificationType.Error" [message]="'fragments-tab.error.failed-to-load' | translate" [icon]="'delete'"></sh-notification>
    }

    @if ((hasVisibleFragments$ | async) && !(isLoading$ | async) && !(loadingError$ | async)) {
        <section>
            <h6 class="sh-clear-margin-bottom">{{ "fragments-tab.parent" | translate }}</h6>
            @if (mainFragmentItem$ | async; as main) {
                <sh-generic-list
                    [rowElements]="main"
                    [highlightedItem]="currentFragmentItem$ | async"
                    [actionItems]="mainFragmentItemActions$ | async"
                    [availableSelect]="false"
                    [columns]="columns"
                ></sh-generic-list>
            }
            <h6>{{ "fragments-tab.children" | translate }}</h6>
            <sh-generic-overview
                [columns]="columns"
                [paginatedResults]="paginatedChildFragmentItems$ | async"
                [highlightedItem]="currentFragmentItem$ | async"
                [actionItems]="childFragmentItemsActions$ | async"
                [hasError]="loadingError$ | async"
                [isLoading]="isLoading$ | async"
                [showViewToggle]="false"
                [allowSort]="false"
                [searchBarMode]="searchBarMode"
                [availableSelect]="false"
                [xxResultsLabelKey]="'general.xx-results.item'"
                [noResultsLabelKey]="'general.no-results.item'"
                (paginationInfoChanged)="onChildFragmentItemsPaginationInfoChanged($event)"
            ></sh-generic-overview>
        </section>
    }
</div>
